import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboardIcon, PackageIcon, MessageSquareIcon, CalendarIcon, ClockIcon, UsersIcon, BarChart2Icon, FileTextIcon, BrainCircuitIcon, MenuIcon } from 'lucide-react';
import { useRecording } from '../../contexts/RecordingContext';
import { useAISalesAssistant } from '../../contexts/AISalesAssistantContext';
export const TopNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    recordingState
  } = useRecording();
  const {
    toggleAssistant,
    setActiveFeature
  } = useAISalesAssistant();
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const isActive = (path: string) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };
  const navItems = [{
    name: 'Dashboard',
    path: '/dashboard',
    icon: <LayoutDashboardIcon className="w-5 h-5" data-id="element-2766" />,
    notifications: 0
  }, {
    name: 'Products',
    path: '/products',
    icon: <PackageIcon className="w-5 h-5" data-id="element-2767" />,
    notifications: 0
  }, {
    name: 'Bookings',
    path: '/bookings',
    icon: <CalendarIcon className="w-5 h-5" data-id="element-2768" />,
    notifications: 2
  }, {
    name: 'Waiting List',
    path: '/waitinglist',
    icon: <ClockIcon className="w-5 h-5" data-id="element-2769" />,
    notifications: 3
  }, {
    name: 'Customers',
    path: '/customers',
    icon: <UsersIcon className="w-5 h-5" data-id="element-2770" />,
    notifications: 0
  }, {
    name: 'Reports',
    path: '/reports',
    icon: <BarChart2Icon className="w-5 h-5" data-id="element-2771" />,
    notifications: 0
  }, {
    name: 'Documents',
    path: '/documents',
    icon: <FileTextIcon className="w-5 h-5" data-id="element-2772" />,
    notifications: 0
  }];
  // Filter out Enquiries item
  const displayedNavItems = navItems.filter(item => item.name !== 'Enquiries');
  return <div className="bg-white border-b border-gray-200 sticky top-0 z-30" data-id="element-2773">
      <div className="flex items-center px-4 py-2" data-id="element-2774">
        {/* Logo */}
        <div className="flex items-center mr-4 md:mr-6" data-id="element-2775">
          <div className="bg-teal-600 text-white font-bold rounded-md p-2 mr-2" data-id="element-2776">
            <span className="text-sm" data-id="element-2777">TP</span>
          </div>
          <h1 className="text-lg font-bold text-gray-800" data-id="element-2778">TravelPro</h1>
          <span className="ml-2 px-2 py-0.5 bg-gray-100 text-xs font-medium rounded" data-id="element-2779">
            SALESKIT
          </span>
        </div>
        {/* Mobile menu button */}
        <button className="md:hidden p-2 text-gray-600 hover:text-teal-600 focus:outline-none" onClick={() => setShowMobileMenu(!showMobileMenu)} data-id="element-2780">
          <MenuIcon className="w-6 h-6" data-id="element-2781" />
        </button>
        {/* Desktop Navigation */}
        <div className="hidden md:flex flex-1 space-x-1" data-id="element-2782">
          {displayedNavItems.map(item => <button key={item.name} className={`flex flex-col items-center px-2 py-1 ${isActive(item.path) ? 'text-teal-600' : 'text-gray-600 hover:text-teal-600'}`} onClick={() => navigate(item.path)} data-id="element-2783">
              <div className="relative" data-id="element-2784">
                {item.icon}
                {item.notifications > 0 && <span className="absolute -top-1.5 -right-1.5 h-4 w-4 bg-red-500 rounded-full text-xs text-white flex items-center justify-center" data-id="element-2785">
                    {item.notifications}
                  </span>}
              </div>
              <span className="text-xs mt-1" data-id="element-2786">{item.name}</span>
            </button>)}
        </div>
        {/* AI Assistant button */}
        <div className="ml-auto md:ml-4 flex items-center" data-id="element-2787">
          <button className={`flex flex-col items-center px-3 py-1 text-gray-600 hover:text-teal-600 relative`} onClick={() => {
          toggleAssistant();
          setActiveFeature(recordingState === 'recording' ? 'audio' : 'insights');
        }} data-id="element-2788">
            <div className="relative" data-id="element-2789">
              <BrainCircuitIcon className="w-5 h-5" data-id="element-2790" />
              {recordingState === 'recording' && <span className="absolute -top-1 -right-1 h-2 w-2 bg-red-500 rounded-full animate-pulse" data-id="element-2791"></span>}
            </div>
            <span className="text-xs mt-1" data-id="element-2792">AI Assistant</span>
          </button>
          {recordingState === 'recording' && <div className="hidden md:flex ml-2 px-2 py-1 bg-red-100 text-red-700 rounded-full text-xs items-center" data-id="element-2793">
              <span className="h-2 w-2 bg-red-500 rounded-full animate-pulse mr-1" data-id="element-2794"></span>
              Recording
            </div>}
        </div>
      </div>
      {/* Mobile Navigation Menu */}
      {showMobileMenu && <div className="md:hidden bg-white border-t border-gray-200 py-2 px-4" data-id="element-2795">
          <div className="grid grid-cols-4 gap-4" data-id="element-2796">
            {displayedNavItems.map(item => <button key={item.name} className={`flex flex-col items-center px-2 py-2 ${isActive(item.path) ? 'text-teal-600 bg-teal-50 rounded-lg' : 'text-gray-600'}`} onClick={() => {
          navigate(item.path);
          setShowMobileMenu(false);
        }} data-id="element-2797">
                <div className="relative" data-id="element-2798">
                  {item.icon}
                  {item.notifications > 0 && <span className="absolute -top-1.5 -right-1.5 h-4 w-4 bg-red-500 rounded-full text-xs text-white flex items-center justify-center" data-id="element-2799">
                      {item.notifications}
                    </span>}
                </div>
                <span className="text-xs mt-1" data-id="element-2800">{item.name}</span>
              </button>)}
          </div>
        </div>}
    </div>;
};